<template>
  <div v-if="filterVersion">
    <div class="mr-4">
      <div
        class="d-flex align-items-center"
        v-if="commonStore.policyFilter.type === 'default'"
      >
        <ag-dropdown
          :options="options"
          :text="
            commonStore &&
            commonStore.policyFilter &&
            commonStore.policyFilter.data.startVersion &&
            Object.keys(commonStore.policyFilter.data.startVersion).length !==
              0 &&
            commonStore.policyFilter.data.startVersion.label
              ? commonStore.policyFilter.data.startVersion.label
              : 'From'
          "
          @onChangeDropdown="setStartVersion"
        ></ag-dropdown>
        <ag-dropdown
          :options="optionsEnd"
          :text="
            commonStore &&
            commonStore.policyFilter &&
            commonStore.policyFilter.data.endVersion &&
            Object.keys(commonStore.policyFilter.data.endVersion).length !==
              0 &&
            commonStore.policyFilter.data.endVersion.label
              ? commonStore.policyFilter.data.endVersion.label
              : 'To'
          "
          @onChangeDropdown="setEndVersion"
        ></ag-dropdown>
        <button v-if="!hideApplyButton" class="ag-table-button" @click="apply">
          Apply
        </button>
      </div>
      <div
        class="d-flex align-items-center"
        v-if="commonStore.policyFilter.type === 'interval'"
      >
        <ag-date-select
          @onDateChanged="onDateChanged"
          :filters="filters"
          :default-value="defaultDate"
          :dateid="'card'"
          :customDate="false"
        />
        <button class="ag-table-button" @click="apply" v-if="!hideApplyButton">
          Apply
        </button>
      </div>
      <a
        href="#"
        class="link pull-right"
        v-if="commonStore.policyFilter.type === 'default'"
        style="color: #4c8dbb; float: right; text-align: right"
        @click="setType()"
        >Switch to time interval</a
      >
      <a
        href="#"
        class="link pull-right"
        v-if="commonStore.policyFilter.type !== 'default'"
        style="
          color: #4c8dbb;
          float: right;
          text-align: right;
          min-width: 190px;
        "
        @click="setType()"
        >Switch to version interval</a
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import AgDropdown from "@/components/ag-dropdown";
import AgDateSelect from "@/components/ag-date-select";
import api from "@/api/index";
import axiosApi from "@/store/axiosAgsc";

import { useCommonStore } from "@/stores/common";
import { mapStores } from "pinia";

export default {
  components: {
    AgDropdown,
    AgDateSelect,
  },
  props: {
    module: {
      type: Object,
      default: null,
    },
    readyToUseFilters: {
      type: Object,
      default: () => {
        return {};
      },
    },
    filterVersion: {
      type: Boolean,
      default: false,
    },
    hideApplyButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
      valueTo: null,
      selectedDate: {},
      data: null,
      options: [],
      optionsEnd: [],
      filters: [
        {
          title: "Time Range",
          type: "date",
          param: "range",
          apiEquivalent: "range",
          hidden: true,
          vmodel: null,
        },
      ],
    };
  },
  computed: {
    ...mapStores(useCommonStore),
    defaultDate() {
      if (this.commonStore.dropdownDate) {
        return this.commonStore.dropdownDate;
      } else {
        return "Last 7 days";
      }
    },
  },
  methods: {
    setType() {
      this.commonStore.policyFilter.type =
        this.commonStore.policyFilter.type == "default"
          ? "interval"
          : "default";
      this.commonStore.setPolicyFilter({
        type: this.commonStore.policyFilter.type,
        data: this.commonStore.policyFilter.data,
      });
    },
    onDateChanged(data) {
      this.data = data;
      if (this.data.value !== "custom") {
        this.commonStore.setDateFilter(this.data);
      }
      if (data.value === "custom") {
        document.getElementById("filterDateRangeCustom").click();
      }
      if (this.hideApplyButton) {
        this.valueChanged();
      }
    },
    setStartVersion(data) {
      this.value = data;
      this.commonStore.setPolicyFilter({
        type: this.commonStore.policyFilter.type,
        data: {
          startVersion: data,
          endVersion: this.commonStore.policyFilter.data.endVersion,
        },
      });
      this.optionsEnd = [];
      this.options.forEach((element) => {
        if (element.value >= data.value) {
          this.optionsEnd.push(element);
        }
      });
      if (this.hideApplyButton) {
        this.valueChanged();
      }
    },
    setEndVersion(data) {
      this.valueTo = data;
      this.commonStore.setPolicyFilter({
        type: this.commonStore.policyFilter.type,
        data: {
          startVersion: this.commonStore.policyFilter.data.startVersion,
          endVersion: data,
        },
      });
      if (this.hideApplyButton) {
        this.valueChanged();
      }
    },
    apply() {
      this.$emit("onVersionChanged", {
        type: this.commonStore.policyFilter.type,
        data: this.data,
        version: {
          start: this.value ? this.value.value : null,
          end: this.valueTo ? this.valueTo.value : null,
        },
      });
      if (this.data) {
        this.commonStore.setDropdownDate(this.data.label);
        this.commonStore.setHourDifference(this.data.hourDifference);
        if (this.data.value !== "custom") {
          this.commonStore.setDateFilter(this.data);
        }
      }
    },
    valueChanged() {
      this.$emit("onValueChanged", {
        type: this.commonStore.policyFilter.type,
        data: this.data,
        version: {
          start: this.value ? this.value.value : null,
          end: this.valueTo ? this.valueTo.value : null,
        },
      });
    },
  },
  async mounted() {
    const module = this.module;
    const readyToUseFilters = this.readyToUseFilters;
    const range = module.filters.find((f) => f.param == "range");
    const jQuery = window.jQuery;
    jQuery.noConflict();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    jQuery('input[name="dates"]').daterangepicker(
      {
        showDropdowns: true,
        opens: "center",
        drops: "down",
        timePicker: true,
        timeFormat: 'hh:mm A',
        startDate: moment().startOf('day').hour(0).minute(0),
        endDate: moment().endOf('day').hour(23).minute(59),
      },
      function (start, end) {
        self.commonStore.setDateFilter({
          label: "Custom Range",
          value: start,
          endDate: end,
        });

        try {
          range.vmodel = {
            start: start.format("YYYY-MM-DD hh:mm A"),
            end: end.format("YYYY-MM-DD hh:mm A"),
          };
          range.selectedLabel = `${start.format("L")} - ${end.format("L")}`;
          // range.vmodel = null;
          const filter = readyToUseFilters.readyToUseFilters;
          filter.startDate = start.format("YYYY-MM-DD hh:mm A");
          filter.endDate = end.format("YYYY-MM-DD hh:mm A");
          readyToUseFilters.readyToUseFilters = filter;
          readyToUseFilters.component.options.fetchTable(
            readyToUseFilters.component.options
          );
        } catch (error) {
          console.log(error);
        }
      }
    );

    let groupGuid = 0;
    try {
      let groupString = localStorage.getItem("group");
      let group = JSON.parse(groupString);
      if (group) {
        groupGuid = group.key;
      }
      if(!groupGuid || typeof groupGuid === 'undefined') {
        return;
      }

      axiosApi
        .get(
          `/Event/GetEventsPolicyFileVersionByGroupGuid?groupGuid=${groupGuid}`,
          null
        )
        .then((response) => {
          if(!response || !response.data) {
            return;
          }
          response.data.forEach((element) => {
            this.options.push({
              value: element.version,
              label: `V ${element.userFriendlyVersion}`,
            });
            this.setStartVersion(this.options[0])
          });
        });
    } catch (error) {
      console.log(error);
    }
  },
};
</script>


<style lang="scss" scoped>
.ag__dropdown {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 8px;
  position: relative;
  min-width: 144px;

  &__menu {
    color: #212529;
    list-style: none;
    background-color: #fff;
    margin: 1px 0;
    position: absolute;
    top: 100%;
    z-index: 999;
    width: 100%;

    max-height: 0;
    transition: 0.15s ease-out;
    overflow: hidden;
    background: #d5d5d5;
  }

  $this: &;

  &.active {
    #{$this}__menu {
      max-height: 500px;
      transition: 0.25s ease-in;
      box-shadow: 1px 4px 6px 0px rgb(119 119 119 / 42%);
    }

    .ag-icon_greyRightArrow {
      transform: rotate(-90deg);
    }
  }

  &__item {
    padding: 6px 8px;
    font-size: 14px;
    color: white;
    cursor: pointer;
    color: #808080;
    background-color: #f8f8f8;
    flex: 0;
    transition: color, background-color 0.3s ease-in-out;
    -webkit-transition: color, background-color 0.3s ease-in-out;
    -moz-transition: color, background-color 0.3s ease-in-out;
    min-width: 100%;

    &--active {
      display: flex;
      align-items: center;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
      padding: 8px;
      box-shadow: 1px 4px 6px 0px rgb(119 119 119 / 42%);
      border-radius: 4px;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
    }

    &:not(&--active):hover {
      text-decoration: none;
      color: #4c8dbb;
    }

    &__text {
      flex-grow: 1;
    }
  }

  .ag-icon {
    margin-left: 5px;
  }

  .ag-icon_greyRightArrow {
    width: 12px;
    height: 12px;
    transform: rotate(90deg);
    margin: 0 !important;
    transition: transform 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    -webkit-transition: transform 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    -moz-transition: transform 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  }
}
</style>

